export default function ExitConfirmModal({
  open,
  onClose,
  onConfirm,
  gameName = "this game",
}) {
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-80">
      <div className="bg-slate-900 border-2 border-lime-400 p-8 rounded-2xl shadow-xl max-w-xs w-full flex flex-col items-center">
        <div className="mb-3 text-lime-300 font-bold text-lg">
          Are you sure you want to leave?
        </div>
        <div className="text-slate-200 text-center mb-5">
          If you exit {gameName},{" "}
          <span className="text-pink-400 font-bold">
            you will forfeit and lose your bet
          </span>
          . Your opponent will win.
        </div>
        <div className="flex gap-3 w-full">
          <button
            className="flex-1 bg-slate-700 text-white rounded-xl py-2 font-semibold hover:bg-slate-800"
            onClick={onClose}
          >
            Cancel
          </button>
          <button
            className="flex-1 bg-pink-400 text-[#161f2b] font-bold rounded-xl py-2 hover:bg-pink-300"
            onClick={onConfirm}
          >
            Forfeit & Leave
          </button>
        </div>
      </div>
    </div>
  );
}
